// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3yHHM","info":"PatientInfo_info__1Dg-p"};